import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import { NumericFormat } from "react-number-format";
import * as S from './styled';
//Components
import { useEffect } from 'react';
import LayoutModal from '../../../LayoutModal';
import Loading from "../../../Loading";
//hooks 
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from "../../../../hooks/useLoading";
//Interface 
import { Inputs } from 'Interfaces/IService';
import { ICreate } from 'Interfaces/ICreate';
export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`service/${selectedUrlId}`);
      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const toUpperCaseStrings = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.toUpperCase() : value,
      ])
    );
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = toUpperCaseStrings(data);
      const response = await apiRequest(`service/${selectedUrlId}`, 'PATCH', payload);
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Serviço"
        subTitle="Atualize informações do serviço em sua base de dados."
        setModalClose={setModalClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Serviço'}
      >
        {
          isLoading ? (
            <Loading />
          ) :
            <S.Container>
              <S.SeparateDiv>
                <S.FormInput>
                  <S.Label>
                    Nome do Serviço
                    <span>*</span>
                  </S.Label>
                  <S.Input
                    placeholder="Informe o serviço"
                    type="text"
                    {...register("name", { required: true })}
                  />
                  {errors.name && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>

                <S.FormInput>
                  <S.Label>
                    Valor da Venda R$
                    <span>*</span>
                  </S.Label>
                  <Controller
                    name="price"
                    control={control}
                    rules={{ required: "Este campo é obrigatório" }}
                    render={({ field: { onChange, value, ref } }) => (
                      <NumericFormat
                        thousandSeparator="."
                        decimalSeparator=","
                        decimalScale={2}
                        fixedDecimalScale={true}
                        placeholder="R$ 0,00"
                        prefix="R$ "
                        value={value}
                        onValueChange={(values) => {
                          const purchaseValue = values.floatValue ?? 0;
                          onChange(purchaseValue);
                        }}
                        getInputRef={ref}
                      />
                    )}
                  />
                  {errors.price && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>
              </S.SeparateDiv>

              <S.FormInput>
                <S.Label>Descrição</S.Label>
                <S.TextArea
                  placeholder="Campo Opcional"
                  rows={2}
                  {...register("description")}
                />
              </S.FormInput>
            </S.Container>
        }

      </LayoutModal>
    );
  }
  return null;
}